/**
 * Navigation System
 * Handles mobile menu toggle, accordion, and body scroll lock
 */

(function() {
    'use strict';

    // DOM Elements
    const mobileToggle = document.querySelector('.mobile-menu-toggle');
    const mobileToggleHeader = document.querySelector('.mobile-menu-toggle-header');
    const navPanel = document.querySelector('.nav-panel');
    const mobileOverlay = document.querySelector('.mobile-overlay');
    const navItemsWithDropdown = document.querySelectorAll('.nav-item.has-mega-menu, .nav-item.has-dropdown');
    const body = document.body;

    // State
    let isMobileMenuOpen = false;

    /**
     * Reserve the space occupied by Shopify's top-layer preview bar.
     * Read the wrapper geometry without accessing its cross-origin iframe.
     */
    function initializePreviewBarOffset() {
        if (!navPanel || !window.Shopify || !window.Shopify.previewMode) {
            return;
        }

        let previewBar = null;
        let updateFrame = null;
        const resizeObserver = new ResizeObserver(scheduleUpdate);
        const barObserver = new MutationObserver(scheduleUpdate);

        function scheduleUpdate() {
            if (updateFrame === null) {
                updateFrame = window.requestAnimationFrame(updateOffset);
            }
        }

        function updateOffset() {
            updateFrame = null;
            const nextBar = document.getElementById('PBarNextFrameWrapper');

            if (nextBar !== previewBar) {
                resizeObserver.disconnect();
                barObserver.disconnect();
                previewBar = nextBar;
                if (previewBar) {
                    resizeObserver.observe(previewBar);
                    barObserver.observe(previewBar, { attributes: true });
                    previewBar.addEventListener('toggle', scheduleUpdate);
                }
            }

            let offset = 0;
            if (isMobile() && previewBar && previewBar.getClientRects().length) {
                const viewport = window.visualViewport;
                const viewportTop = viewport ? viewport.offsetTop : 0;
                const viewportHeight = viewport ? viewport.height : window.innerHeight;
                const viewportBottom = viewportTop + viewportHeight;
                const rect = previewBar.getBoundingClientRect();
                const panelRect = navPanel.getBoundingClientRect();
                const style = window.getComputedStyle(previewBar);
                // Use the open panel's footprint even while it is translated off-screen.
                const overlapsPanel = rect.right > 0 && rect.left < panelRect.width;

                if (style.visibility !== 'hidden' && overlapsPanel && rect.height > 0 &&
                    rect.bottom > viewportTop && rect.top < viewportBottom) {
                    offset = Math.min(viewportHeight, Math.max(0, viewportBottom - rect.top));
                }
            }

            navPanel.style.setProperty('--preview-bar-offset', `${offset}px`);
        }

        // Shopify injects and removes its wrapper directly under the body.
        new MutationObserver(scheduleUpdate).observe(body, { childList: true });
        window.addEventListener('resize', scheduleUpdate);
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', scheduleUpdate);
            window.visualViewport.addEventListener('scroll', scheduleUpdate);
        }
        scheduleUpdate();
    }

    /**
     * Toggle Mobile Menu
     */
    function toggleMobileMenu() {
        isMobileMenuOpen = !isMobileMenuOpen;

        if (isMobileMenuOpen) {
            navPanel.classList.add('active');
            mobileOverlay.classList.add('active');
            // Lock body scroll - iOS Safari fix
            body.style.overflow = 'hidden';
            body.style.position = 'fixed';
            body.style.width = '100%';
        } else {
            navPanel.classList.remove('active');
            mobileOverlay.classList.remove('active');
            // Unlock body scroll - iOS Safari fix
            body.style.overflow = '';
            body.style.position = '';
            body.style.width = '';
            closeAllAccordions(); // Close all accordions when menu closes
        }
    }

    /**
     * Close Mobile Menu
     */
    function closeMobileMenu() {
        if (isMobileMenuOpen) {
            isMobileMenuOpen = false;
            navPanel.classList.remove('active');
            mobileOverlay.classList.remove('active');
            // Unlock body scroll - iOS Safari fix
            body.style.overflow = '';
            body.style.position = '';
            body.style.width = '';
            closeAllAccordions();
        }
    }

    /**
     * Toggle Mobile Accordion
     * Only one accordion open at a time
     */
    function toggleAccordion(navItem) {
        const isActive = navItem.classList.contains('active');

        // Close all accordions first
        closeAllAccordions();

        // If it wasn't active, open it
        if (!isActive) {
            navItem.classList.add('active');
        }
    }

    /**
     * Close All Accordions
     */
    function closeAllAccordions() {
        navItemsWithDropdown.forEach(item => {
            item.classList.remove('active');
        });
    }

    /**
     * Check if viewport is mobile
     */
    function isMobile() {
        return window.innerWidth <= 768;
    }

    /**
     * Handle Window Resize
     */
    function handleResize() {
        if (!isMobile() && isMobileMenuOpen) {
            closeMobileMenu();
        }
    }

    /**
     * Event Listeners
     */

    // Mobile toggle button (in nav)
    if (mobileToggle) {
        mobileToggle.addEventListener('click', toggleMobileMenu);
    }

    // Mobile toggle button (in header)
    if (mobileToggleHeader) {
        mobileToggleHeader.addEventListener('click', toggleMobileMenu);
    }

    // Overlay click to close
    if (mobileOverlay) {
        mobileOverlay.addEventListener('click', closeMobileMenu);
    }

    // Accordion click (only on mobile)
    navItemsWithDropdown.forEach(navItem => {
        const navLink = navItem.querySelector('.nav-link');
        
        if (navLink) {
            navLink.addEventListener('click', function(e) {
                if (isMobile()) {
                    e.preventDefault();
                    toggleAccordion(navItem);
                }
            });
        }
    });

    // Handle window resize
    window.addEventListener('resize', handleResize);

    initializePreviewBarOffset();

    // Close menu on ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isMobileMenuOpen) {
            closeMobileMenu();
        }
    });

    /**
     * Initialize
     */
    console.log('Navigation system initialized');
})();
